import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Bell(props) {
    return (
        <SvgIcon {...props}>
            <path d="M28.1 24.7L25.8 22v-8.6c0-4.7-3.3-8.8-7.8-9.7v-.3c0-1.1-.9-2-2-2s-2 .9-2 2v.3c-4.5.9-7.8 4.9-7.8 9.7V22L4 24.7c-.2.2-.2.5-.1.8.1.3.4.4.6.4h23c.3 0 .5-.2.6-.4.1-.3.1-.6 0-.8zm-4.2-11.3v8.7l1.3 1.8H6.8l1.3-1.8v-8.7c0-4.4 3.5-8 7.9-8 4.3.1 7.9 3.6 7.9 8zm-4.5 13.2h1.9v.2c0 1.1-.6 2-1.6 2.7-1 .7-2.3 1.1-3.7 1.1-1.4 0-2.7-.4-3.7-1.1-1-.7-1.6-1.7-1.6-2.7v-.2h1.9v.2c0 .4.4.9 1 1.2.6.4 1.5.6 2.4.6.9 0 1.7-.2 2.4-.6.6-.3 1-.8 1-1.2v-.2z" />
        </SvgIcon>
    );
}

Bell.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Bell;
